<div class="process-section">

    <!-- Toggle Header -->
    <div class="section-header process-toggle-header" (click)="toggleSection()" role="button"
        [attr.aria-expanded]="isExpanded()">
        <div class="header-left">
            <h4 class="section-title">
                <mat-icon>directions_car</mat-icon>
                Parking Processes
            </h4>
            <!-- Inline stats (always visible) -->
            <div class="inline-stats">
                <span class="stat-chip active-chip">
                    <mat-icon class="chip-icon">radio_button_checked</mat-icon>
                    {{ activeProcessCount() }} active
                </span>
                @if (zoneCapacity > 0) {
                <span [class]="getOccupancyChipClass()">
                    <mat-icon class="chip-icon">pie_chart</mat-icon>
                    {{ occupancyPercentage() }}%
                </span>
                }
                @if (zoneCapacity > 0) {
                <span class="stat-chip capacity-chip">
                    <mat-icon class="chip-icon">local_parking</mat-icon>
                    {{ zoneCapacity }} cap
                </span>
                }
            </div>
        </div>
        <div class="toggle-header-actions">
            @if(isExpanded()) {
            <button mat-icon-button color="primary" (click)="$event.stopPropagation(); loadParkingProcesses()"
                [disabled]="isLoading() || !zoneId" matTooltip="Refresh">
                <mat-icon>refresh</mat-icon>
            </button>
            <mat-icon class="expand-icon" [class.expanded]="isExpanded()">expand_more</mat-icon>
            }
        </div>
    </div>

    @if(isExpanded()) {
    <!-- Expandable Content -->
    <div class="process-content">
        @if(isLoading()) {
        <mat-progress-bar mode="indeterminate" class="mb-3"></mat-progress-bar>
        }
        <!-- Status Filter -->
        <div class="filter-row">
            <mat-button-toggle-group [value]="selectedFilter()" (change)="onFilterChange($event.value)"
                class="filter-toggle-group">
                <mat-button-toggle value="all">
                    <mat-icon class="toggle-icon">list</mat-icon>
                    All ({{ parkingProcesses().length }})
                </mat-button-toggle>
                <mat-button-toggle value="active">
                    <mat-icon class="toggle-icon text-green-600">radio_button_checked</mat-icon>
                    Active ({{ activeProcessCount() }})
                </mat-button-toggle>
                <mat-button-toggle value="ended">
                    <mat-icon class="toggle-icon text-gray-500">radio_button_unchecked</mat-icon>
                    Ended ({{ parkingProcesses().length - activeProcessCount() }})
                </mat-button-toggle>
            </mat-button-toggle-group>
        </div>

        <!-- Process List -->
        <app-parking-zone-parking-process-list [processes]="filteredProcesses()" [isLoading]="isLoading()">
        </app-parking-zone-parking-process-list>
    </div>
    }
</div>